var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autosuggest',{attrs:{"value":_vm.value,"options":_vm.addresses,"label":_vm.config.PROFILE_ADDRESS_STREET,"loading":_vm.loading,"spinnerColor":_vm.config.COLOR_PRIMARY},on:{"input":_vm.onInput,"select":_vm.onSelect},scopedSlots:_vm._u([{key:"default",fn:function({ option }){return [_vm._v(" "+_vm._s(option.formatted)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }